import { SIQButtonTheme } from "./SIQButtonTheme";
export class SIQFAQBottomBarTheme {
  backgroundColor = "null";
  LikeButton = new SIQButtonTheme();
  DislikeButton = new SIQButtonTheme();
}
//# sourceMappingURL=SIQFAQBottomBarTheme.js.map